import { MerchantOrderStatusEnum } from '@/graphql/generatedTypes';

// Statuses at which an order has (or will have) a shipping label, so the
// "view shipping label" button is shown.
export const SHIPPING_LABEL_ELIGIBLE_STATUSES = new Set([
  MerchantOrderStatusEnum.SentToPicking,
  MerchantOrderStatusEnum.Picked,
  MerchantOrderStatusEnum.InTransit,
  MerchantOrderStatusEnum.Delivered,
  MerchantOrderStatusEnum.Completed,
  MerchantOrderStatusEnum.ReturnToSender,
]);

// Statuses at which the shipping label may actually be viewed/downloaded.
// While an order is only SentToPicking the button is shown but greyed out
// (disabled) - it becomes usable once the order has been picked.
export const SHIPPING_LABEL_VIEWABLE_STATUSES = new Set([
  MerchantOrderStatusEnum.Picked,
  MerchantOrderStatusEnum.InTransit,
  MerchantOrderStatusEnum.Delivered,
  MerchantOrderStatusEnum.Completed,
  MerchantOrderStatusEnum.ReturnToSender,
]);
